import { auth } from '../../lib/firebase';

/**
 * ID トークンを best-effort で強制更新する (custom claims の反映を早める)。
 *
 * custom claims (地区アクセス権 / 引き継ぎ元 uid 群 `linkedUids`) はサーバで更新しても、手元の
 * ID トークンが更新されるまで (既定で最長 1 時間) Firestore/Storage のルール判定に反映されない。
 * 双方向リンク (docs/98 R-70 P6) では**別の端末**の復帰によってこの端末の claims が変わるため、
 * membership の `linkedFromUids` が変わったことを検知したタイミングで 1 回だけ更新を試みる。
 *
 * - 失敗しても何もしない (オフライン等)。投稿や画面遷移を待たせない。
 * - テストで `lib/firebase` を部分 mock している場合 (auth 未定義) も安全に no-op。
 */
export function refreshIdTokenBestEffort(): void {
  try {
    const current = (
      auth as
        | { currentUser?: { getIdToken?: (force: boolean) => Promise<string> } | null }
        | undefined
    )?.currentUser;
    if (!current || typeof current.getIdToken !== 'function') return;
    void current.getIdToken(true).catch(() => undefined);
  } catch {
    // auth 未初期化 / テストの部分 mock (export 未定義でアクセス時に throw) でも no-op。
  }
}
